<div class="loginform">
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
    <div class="signin">Reset Password</div>
    <div class="lblmsg">
      <label id="id_alert" class="logininfo">{{msg}}</label>
    </div>
    <div class="form-floating mb-3 mt-3 position-relative">
      <input [type]="showPassword ? 'text' : 'password'" class="form-control custominput" id="password"
        formControlName="password" placeholder="Enter password" maxlength="15"
        [ngClass]="{ 'is-invalid': f.password.invalid && (f.password.dirty || f.password.touched) }" />

      <label for="password" class="lblfocus">Password</label>

      <!-- Eye icon -->
      <img src="/assets/img/eye_close.svg" class="viewpass" *ngIf="!showPassword" (click)="showPassword = true" />

      <img src="/assets/img/eye_open.svg" class="viewpass" *ngIf="showPassword" (click)="showPassword = false" />
      
      <div *ngIf="f.password.invalid && (f.password.dirty || f.password.touched)" class="danger">
      
        <div *ngIf="f.password.errors?.required">
          Password is required
        </div>
      
        <div *ngIf="f.password.errors?.pattern">
          <ul class="passFlow">
            <li> • Must be 8-15 characters long</li>
            <li> • Must include uppercase and lowercase letters</li>
            <li> • Must include a number and a special character</li>
          </ul>
        </div>
      
      </div>

    </div>


    <div class="form-floating mb-3 position-relative">
      <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control custominput" id="confirm-password"
        formControlName="confirmPassword" placeholder="Enter password" maxlength="15"
        [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />

      <label for="confirm-password" class="lblfocus">Confirm Password</label>

      <!-- Eye icon -->
      <img src="/assets/img/eye_close.svg" class="viewpass" *ngIf="!showConfirmPassword"
        (click)="showConfirmPassword = true" />

      <img src="/assets/img/eye_open.svg" class="viewpass" *ngIf="showConfirmPassword"
        (click)="showConfirmPassword = false" />

      <div *ngIf="submitted && f.confirmPassword.errors" class="danger">
        <div *ngIf="f.confirmPassword.errors.required">
          Confirm Password is required
        </div>
        <div *ngIf="f.confirmPassword.errors.mismatch">
          Confirm password mismatch.
        </div>
      </div>
    </div>
    <div class="btnlogin">
      <button type="submit" class="btn btn-primary btnloginsubmit btncomman">Reset Password</button>
    </div>
  </form>
</div>